import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import {
  LangGraphInstanceService,
  LangGraphInstance,
} from 'src/app/core/services/langgraph-instance.service';

@Component({
  selector: 'app-langgraph-instance-selector',
  templateUrl: './langgraph-instance-selector.component.html',
  standalone: false,
})
export class LangGraphInstanceSelectorComponent implements OnInit, OnDestroy {
  instances: LangGraphInstance[] = [];
  selectedInstance: string | null = null;

  private destroy$ = new Subject<void>();

  constructor(private instanceService: LangGraphInstanceService) {}

  ngOnInit(): void {
    this.instanceService.loadInstances().pipe(takeUntil(this.destroy$)).subscribe();

    this.instanceService.instances
      .pipe(takeUntil(this.destroy$))
      .subscribe((instances) => (this.instances = instances));

    this.instanceService.selectedInstance
      .pipe(takeUntil(this.destroy$))
      .subscribe((selected) => (this.selectedInstance = selected));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onSelectionChange(name: string): void {
    this.instanceService.selectInstance(name);
  }
}
